import { Grid } from "@mui/material"
import { ProductGroupFormValues, WeekDays } from "../productGroupTypes"
import { LocalizedEnum, LocalizedStrict } from "../../../../localization/components/AppLocalized"
import { FormikChip, FormikTimePicker } from "../../../../../shared/components/forms/Formik"
import { DateTime } from "luxon"

export function ProductGroupFormAvailableTime() {
    return (
        <Grid container rowGap={2}>
            <Grid container item gap={1}>
                {Object.values(WeekDays).map((day) => {
                    return (
                        <Grid key={day} item>
                            <LocalizedEnum base="product-group-form-week-day" enumValue={day}>
                                <FormikChip<ProductGroupFormValues> id={day} name="weekDays" value={day}>
                                    {day.toLowerCase()}
                                </FormikChip>
                            </LocalizedEnum>
                        </Grid>
                    )
                })}
            </Grid>
            <Grid container item gap={2} sm={12} direction="row">
                <Grid item sm>
                    <LocalizedStrict id="product-group-form-start-time-picker" attrs={{ label: true }}>
                        <FormikTimePicker<ProductGroupFormValues, DateTime>
                            label={"start time"}
                            name="timeIntervalStart"
                        />
                    </LocalizedStrict>
                </Grid>
                <Grid item sm>
                    <LocalizedStrict id="product-group-form-end-time-picker" attrs={{ label: true }}>
                        <FormikTimePicker<ProductGroupFormValues, DateTime> label="end time" name="timeIntervalEnd" />
                    </LocalizedStrict>
                </Grid>
            </Grid>
        </Grid>
    )
}
